import React, { memo } from 'react';
import { Wrapper, Title, Subheader, Supheader } from './components';
import { purify } from '../../utils/helpers';
function Header({ text, supheader = '', subheader = '', textAlign = 'center', disableEndMargin = false, className, }) {
    return (React.createElement(Wrapper, { className: className, textAlign: textAlign, disableEndMargin: disableEndMargin },
        supheader && React.createElement(Supheader, null, supheader),
        React.createElement(Title, { dangerouslySetInnerHTML: { __html: purify(text) } }),
        subheader && React.createElement(Subheader, null, subheader)));
}
export default memo(Header);
//# sourceMappingURL=header.js.map